import { useContacts } from '../../queries/ContactQueries';
import { useEventTypes } from '../../queries/CommonQueries';
import { useEvent } from '../../queries/EventQueries';
import { useParams } from 'react-router';
import AddUpdateEventForm from '../../components/AddUpdateEventForm';
import AppLayout from '../../components/AppLayout';
import Stepper from '../../components/Stepper';
import { useUserDetails } from '../../helpers/UserContext';
import type { Event } from '../../models/Event';
import ShowPending from '../../components/ShowPending';

export default function UpdateEvent() {
  const [userDetails] = useUserDetails();
  const params = useParams();
  const eventId = params.id ? +params.id : 0;
  const { data: contacts } = useContacts('');
  const { data: eventTypes } = useEventTypes();
  const { data: event } = useEvent(eventId);
  const isLoading = !contacts || !eventTypes || (eventId && !event);

  return (
    <AppLayout>
      <main>
        <h3 className='text-center text-2xl dark:text-gray-300'>Edit Event</h3>
        <Stepper activeIndex={0} />
        {isLoading ? (
          <ShowPending isPending={isLoading} />
        ) : (
          <AddUpdateEventForm
            contacts={contacts}
            eventTypes={eventTypes}
            event={
              event
                ? event
                : ({
                    applicationUserId: userDetails?.userId ?? '',
                    eventId: 0,
                  } as Event)
            }
          />
        )}
      </main>
    </AppLayout>
  );
}
